const failedValidationErrorMessageMap = {
    CALLBACK_CONVERSATION_NOT_SUPPORTED: 'callback',
    FACEBOOK_MESSENGER_OUTBOUND_EXPIRED: 'expired Facebook Messenger',
    PHONE_CONVERSATION_NOT_SUPPORTED: 'phone',
    VOICEMAIL_CONVERSATION_NOT_SUPPORTED: 'voicemail',
    WHATSAPP_OUTBOUND_EXPIRED: 'expired WhatsApp',
};
/** Gets the error message for a failed bulk validation. */
export function getFailedValidationErrorMessage({ csids, error, }) {
    return `${csids.length} ${failedValidationErrorMessageMap[error]} ${csids.length === 1 ? 'conversation is' : 'conversations are'} included in selected conversations`;
}
